const PLAN_LABELS = {
  premium_monthly: 'Premium — Monthly',
  business_monthly: 'Business — Monthly',
  premium_yearly: 'Premium — Yearly',
  business_yearly: 'Business — Yearly',
};

export function formatPlanType(type) {
  if (!type) {
    return null;
  }
  return PLAN_LABELS[type] || type.replace(/_/g, ' ');
}

export function isSubscriptionPlanType(type) {
  return Boolean(type && PLAN_LABELS[type]);
}

export function formatSubscriptionStatus(userData) {
  if (!userData?.hasSubscription) {
    return 'No active subscription';
  }

  if (userData.autoRenew === false) {
    return 'Active — cancels at period end';
  }

  return 'Active';
}

export function formatRenewalDate(subscriptionEndDate) {
  if (!subscriptionEndDate) {
    return null;
  }

  const date = new Date(subscriptionEndDate);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
